import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M23.271 9.847C25.638 7.389 28.846 6.006 32.193 6c1.94.01 3.846.53 5.54 1.513a11.66 11.66 0 0 1 4.14 4.11 1.13 1.13 0 0 1-.259 1.371c-.234.17-.524.24-.806.194a1.1 1.1 0 0 1-.71-.442 9.4 9.4 0 0 0-3.39-3.313 9 9 0 0 0-4.515-1.184 10.17 10.17 0 0 0-5.397 1.51 10.7 10.7 0 0 0-3.878 4.18 11.2 11.2 0 0 0-1.251 5.658 11.15 11.15 0 0 0 1.733 5.518l8.252 13.043a3.2 3.2 0 0 0 1.568 1.32 3.07 3.07 0 0 0 2.018.075 3.2 3.2 0 0 0 1.656-1.2 3.4 3.4 0 0 0 .627-1.994c0-.298.114-.584.317-.795.203-.21.478-.33.765-.33s.563.12.766.33.317.497.317.795a5.7 5.7 0 0 1-1.03 3.365 5.36 5.36 0 0 1-2.776 2.04 5.16 5.16 0 0 1-3.4-.11 5.4 5.4 0 0 1-2.648-2.214l-8.23-13.2a13.34 13.34 0 0 1-2.035-7.13c.006-3.475 1.338-6.806 3.704-9.263"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M32.84 29.998a7.27 7.27 0 0 1-2.011-5.018 7.33 7.33 0 0 1 1.117-3.958 6.94 6.94 0 0 1 3.041-2.654 3.95 3.95 0 0 0-1.834-1.847 3.75 3.75 0 0 0-2.543-.26 3.87 3.87 0 0 0-2.146 1.438 4.13 4.13 0 0 0-.819 2.513c0 .299-.114.585-.317.796-.203.21-.478.329-.765.329s-.563-.119-.766-.33a1.15 1.15 0 0 1-.317-.795 6.43 6.43 0 0 1 1.566-4.209 6 6 0 0 1 3.877-2.04 5.9 5.9 0 0 1 4.195 1.178 6.32 6.32 0 0 1 2.36 3.79c.052.288-.004.586-.157.833a1.1 1.1 0 0 1-.666.493 4.68 4.68 0 0 0-2.735 1.93 5 5 0 0 0-.823 3.326 4.92 4.92 0 0 0 1.501 3.06 4.6 4.6 0 0 0 3.075 1.264c.287 0 .562.119.765.33.203.21.317.497.317.795a1.17 1.17 0 0 1-.323.788c-.202.21-.474.33-.76.336a6.74 6.74 0 0 1-4.832-2.088M7.098 26.239a1 1 0 0 1-.427-.093 1 1 0 0 1-.352-.267 1.14 1.14 0 0 1 0-1.574c1.485-1.491 2.341-3.532 2.382-5.677a8.3 8.3 0 0 0-2.166-5.77 1.16 1.16 0 0 1-.025-1.648c.107-.106.235-.19.375-.243a1.05 1.05 0 0 1 .864.053q.201.107.345.287c1.828 1.978 2.825 4.628 2.773 7.369s-1.152 5.348-3.054 7.248a1.04 1.04 0 0 1-.715.315"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M10.093 9.543c.062.14.15.267.261.37 2.118 2.265 3.3 5.3 3.292 8.456a11.4 11.4 0 0 1-.847 4.377 11.1 11.1 0 0 1-2.445 3.674 1.16 1.16 0 0 0 0 1.597q.153.164.356.252c.134.058.279.087.424.085a.94.94 0 0 0 .4-.076 1 1 0 0 0 .336-.24 13.3 13.3 0 0 0 2.93-4.413 13.7 13.7 0 0 0 1.012-5.256c.005-3.736-1.394-7.326-3.898-10.007a1.1 1.1 0 0 0-.346-.287 1.05 1.05 0 0 0-1.239.19 1.16 1.16 0 0 0-.236 1.278"
    }
  )
);
var SvgListenOnOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ListenOnOutlined_default = SvgListenOnOutlined;

export { ListenOnOutlined_default as default };
